<form [formGroup]="form" *ngIf="ocultedCountries">
    <div class="select-container">
        <ng-select formControlName="countries" class="countries" [items]="countriesArray" bindLabel="name" [clearable]="false" bindValue="code" [searchable]="false"></ng-select>
    </div>
</form>